export enum CoercionType {
    Text = 0,
    Html = 3,
}
